<h1 mat-dialog-title>
    <span [translate]="'global.liste.filtres.popupTilte'"></span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form>
        <div class="row">
            <div *ngFor="let filter of data.listeFilters" class="col-3">
                <button *ngIf="!filter.isSelected || filter.isHiddenByDefault" mat-stroked-button color="primary" class="filters-button" (click)="onFilterClick(filter)">
                    {{ filter.title }}
                </button>
                <button *ngIf="filter.isSelected && !filter.isHiddenByDefault" mat-flat-button color="primary" class="filters-button" (click)="onFilterClick(filter)">
                    {{ filter.title }}
                </button>
            </div>
        </div>
    </form>
</div>
